var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible(_vm.node)
    ? _c("div", { staticClass: "step-node card mb-3", class: _vm.cardClass }, [
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c(
              "div",
              {
                staticClass: "d-flex align-items-start justify-content-between",
              },
              [
                _c("div", { staticClass: "pr-2" }, [
                  _c("div", { staticClass: "font-weight-bold mb-2" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.node.title) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.node.description
                    ? _c("div", { staticClass: "text-muted small mb-2" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.node.description) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm.indexLabel
                  ? _c("div", { staticClass: "text-muted small ml-2" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.indexLabel) +
                          "\n            "
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c("b-form-radio-group", {
              staticClass: "mt-1",
              attrs: {
                id: "q-" + _vm.node.id,
                name: "q-" + _vm.node.id,
                value: _vm.answerValue,
                "button-variant": "outline-primary",
                options: _vm.yesNoOptions,
                buttons: "",
              },
              on: { input: _vm.onAnswerInput },
            }),
            _vm._v(" "),
            _vm.showErrors &&
            _vm.answerValue !== true &&
            _vm.answerValue !== false
              ? _c("div", { staticClass: "text-danger small mt-2" }, [
                  _vm._v(
                    "\n            Будь ласка, оберіть відповідь.\n        "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.commentVisible
              ? _c(
                  "div",
                  { staticClass: "mt-3" },
                  [
                    _vm.node.comment_description
                      ? _c("div", { staticClass: "text-muted small mb-1" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.node.comment_description) +
                              "\n            "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("b-form-textarea", {
                      attrs: {
                        value: _vm.commentValue,
                        rows: "3",
                        "max-rows": "6",
                        placeholder: "Вкажіть коментар...",
                      },
                      on: { input: _vm.onCommentInput },
                    }),
                    _vm._v(" "),
                    _vm.showErrors && _vm.commentRequired && !_vm.commentOk
                      ? _c("div", { staticClass: "text-danger small mt-2" }, [
                          _vm._v(
                            "\n                Коментар обов’язковий.\n            "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _vm.hasChildren
          ? _c(
              "div",
              { staticClass: "px-3 pb-3" },
              _vm._l(_vm.node.children, function (child) {
                return _c("StepNode", {
                  key: child.id,
                  attrs: {
                    node: child,
                    answers: _vm.answers,
                    yesNoOptions: _vm.yesNoOptions,
                    isVisible: _vm.isVisible,
                    isCommentRequired: _vm.isCommentRequired,
                    showErrors: _vm.showErrors,
                    indexMap: _vm.indexMap,
                  },
                  on: {
                    setAnswer: function ($event) {
                      return _vm.$emit("setAnswer", ...arguments)
                    },
                    setComment: function ($event) {
                      return _vm.$emit("setComment", ...arguments)
                    },
                  },
                })
              }),
              1
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }